import gql from 'graphql-tag';

import type { FindUserEmailsByUserIdResponse } from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1/user_emails_api';

export type FindUserEmailsByUserIdQueryVariables = {
  userId: string;
};

export type FindUserEmailsByUserIdQueryResult = {
  FindUserEmailsByUserIdResponse: FindUserEmailsByUserIdResponse;
};

export type UpdateGlobalOptOutMutationVariables = {
  userId: string;
  enabled?: boolean;
  body: {};
};

export const UpdateGlobalOptOutMutation = gql`
  mutation UpdateGlobalOptOut($userId: String!, $enabled: Boolean, $body: DataMap!) {
    UpdateGlobalOptOut(userId: $userId, enabled: $enabled, body: $body)
      @rest(
        type: "NotificationPreferencesV2"
        path: "notificationPreferences.v2/?action=updateGlobal&enabled={args.enabled}&id={args.userId}"
        method: "POST"
        bodyKey: "body"
      ) {
      global
    }
  }
`;

export type UpdateNotificationPreferencesMutationVariables = {
  userId: string;
  body: {};
};

export const UpdateNotificationPreferencesMutation = gql`
  mutation UpdateNotificationPreferences($userId: String!, $body: DataMap!) {
    UpdateNotificationPreferences(userId: $userId, body: $body)
      @rest(
        type: "NotificationPreferencesV2"
        path: "notificationPreferences.v2/{args.userId}"
        method: "PUT"
        bodyKey: "body"
      ) {
      elements
    }
  }
`;

export const EmailPreferencesQuery = gql`
  query EmailPreferencesQuery($userId: String!) {
    EmailPreferencesQuery(userId: $userId)
      @rest(type: "NotificationPreferencesV2", path: "notificationPreferences.v2/{args.userId}", method: "GET") {
      elements
    }
  }
`;

export const FindUserEmailsByUserIdQuery = gql`
  query FindUserEmailsByUserIdQuery($userId: String!) {
    FindUserEmailsByUserIdResponse(userId: $userId)
      @rest(
        type: "FindUserEmailsByUserId"
        path: "grpc/useremails/v1/UserEmailsAPI/FindUserEmailsByUserId?{args}"
        method: "GET"
      ) {
      userEmails
    }
  }
`;
